export default {
  SET_PAGINATION(state, data) {
      state.pagination = data
  },
  ADD_USER(state, user) {
    state.users.push(user)
  },
  UPDATE_USER(state, user) {
    const userIndex = state.users.findIndex((e) => e.id === user.id)
    Object.assign(state.users[userIndex], user)
  },
  SET_USERS (state, users) {
    state.users = users
  },
  REMOVE_RECORD (state, itemId) {
    const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.users.splice(userIndex, 1)
  }
}
